// src/components/TwitterImageCardMeta.tsx

import React from "react";
import { Helmet } from "react-helmet-async";

interface TwitterImageCardMetaProps {
  imageUrl: string;
  title?: string;
  description?: string;
  pageUrl?: string;
}

const TwitterImageCardMeta: React.FC<TwitterImageCardMetaProps> = ({
  imageUrl,
  title = "Global24 News",
  description = "Stay informed with the latest global headlines.",
  pageUrl = typeof window !== "undefined" ? window.location.href : "",

}) => {
  return (
    <Helmet>
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:alt" content={title} />
      <meta name="twitter:url" content={pageUrl} />
      <meta name="twitter:site" content="@Global24News" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={pageUrl} />
    </Helmet>
  );
};

export default TwitterImageCardMeta;
